import { CommonUtils } from '@farris/ui-common';
import { Injectable, LOCALE_ID, Inject, InjectionToken, Optional } from '@angular/core';

import { FARRIS_LOCALES } from './locales';

export const FARRIS_LOCAL_CUSTOM_DATA = new InjectionToken('èªå®ä¹è¯­è¨æ°æ®ï¼ æ ¼å¼ï¼{ "languageCode": { "name": { "key": "value" } } }');
@Injectable({
    providedIn: 'root'
})
export class LocaleService {

    langData: any;

    constructor(@Inject(LOCALE_ID) public localeId: string, private utils: CommonUtils,
                @Optional() @Inject(FARRIS_LOCAL_CUSTOM_DATA) private localeData: any) {
        if (!localeId) {
            localeId = 'zh-CHS';
        }

        // åå¹¶è¯­è¨èµæº
        this.setLocaleData(localeData);
    }

    /** è·åè¯­è¨èµæº
     *  path : èµæºè·¯å¾ï¼å¦:
     *  ```
     *  getResources('zh-CHS') // è¿åææä¸­æè¯­è¨èµæº
     *  getResources('zh-CHS.lookup') // è¿åææä¸­æä¸å¸®å©çèµæº
     *  ```
     */
    getResources( path = '') {
        if (path) {
            return this.utils.getValue(path, FARRIS_LOCALES);
        }
        return FARRIS_LOCALES;
    }

    getComponentOptions(ctrlName) {
        return this.langData[ctrlName];
    }

    getValue(propertyName: string) {
        const val = this.utils.getValue(propertyName, this.langData);
        if (val) {
            return val;
        } else {
            // console.warn(`Can\'t find language Data for the ${propertyName}`);
            return '';
        }
    }

    /** åå¹¶ç°æçå¤è¯­èµæº */
    setLocaleData(localeData = null) {
        if (localeData) {
            // è§£æå¾å°æä¾çè¯­è¨ç¼ç 
            const langCodes = Object.keys(localeData);
            langCodes.forEach((code: string) => {
                const resName = Object.keys(localeData[code]);
                resName.forEach(k => {
                    this.appendLanguageResource(k, localeData[code][k], code);
                });
            });
        }

        this.langData = FARRIS_LOCALES[this.localeId];
        if (!this.langData) {
            this.langData = FARRIS_LOCALES['zh-CHS'];
        }
    }

    private appendLanguageResource(key: string, data: any, lang: string = this.localeId) {
        if (!lang) {
            this.langData[key] = this.langData[key] || {};
            this.langData[key] = Object.assign(this.langData[key], data || {});
        } else {
            FARRIS_LOCALES[lang][key] = data || {};
        }
    }
}
